module.exports = __webpack_public_path__ + "43b0cb205f5b7df475243afcf07b0d7a.pdf";